var React = require('react');

function Chevron (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M2309.9,418.441l-3.406-6.247a1.252,1.252,0,0,0-2.2,1.2l3.087,5.662-3.087,5.662a1.252,1.252,0,1,0,2.2,1.2l3.406-6.247a1.313,1.313,0,0,0,0-1.227Z","transform":"translate(-2304.147 -411.541)","fill":"#ebebed"}));
}

Chevron.defaultProps = {"focusable":"false","width":"5.91","height":"15.027","viewBox":"0 0 5.91 15.027"};

module.exports = Chevron;

Chevron.default = Chevron;
